import { useState } from "react";
import { userDataState } from "../../state/storeDataStateType";
import { GrowthContainer } from "./style";
import { SimpleSidebar } from "@bikdotai/bik-component-library";
import CustomizedJourneys from "./CustomizedJourneys";
import { SidebarEnums } from "./type";
import { WhatsNewPanel } from "../../features/whats-new";
import ServiceFeaturesDashboard from "../../admin/service-features/ServiceFeaturesDashboard";
import { Menu } from "@bikdotai/bik-component-library/dist/esm/components/bik-layout/Sidebar.model";

export const MenuItems: Menu[] = [
  {
    key: SidebarEnums["tailored-section"],
    displayName: "Tailored for you",
  },
  {
    key: SidebarEnums["recommended-section"],
    displayName: "Recommended for you",
  },
  {
    key: SidebarEnums["whats-new-section"],
    displayName: "What's new",
  },
  {
    key: SidebarEnums["service-features-section"],
    displayName: "Service Features",
  },
];

const GrowthBlock: React.FC<{ userData: userDataState }> = ({ userData }) => {
  const [currentMenu, setCurrentMenu] = useState(MenuItems[0]);

  return (
    <>
      <GrowthContainer>
        <div className="growth-global-container">
          <SimpleSidebar
            menuList={MenuItems}
            activeMenu={currentMenu}
            theme={"white"}
            onMenuClick={function (menuSelected: Menu): void {
              setCurrentMenu(menuSelected);
            }}
            router={undefined}
          />
          <div className="growth-component-container">
            <CustomizedJourneys currentMenu={currentMenu} />
            {currentMenu.key === SidebarEnums["whats-new-section"] && (
              <WhatsNewPanel />
            )}
            {currentMenu.key === SidebarEnums["service-features-section"] && (
              <ServiceFeaturesDashboard />
            )}
          </div>
        </div>
      </GrowthContainer>
    </>
  );
};

export default GrowthBlock;
